module.exports = __webpack_public_path__ + "img/btn.01d0cf14.png";